// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode[data-v-2caae675]{position:relative}.qrcode>img[data-v-2caae675]{display:block}.qrcode>.mask[data-v-2caae675],.qrcode>img[data-v-2caae675]{margin:auto;width:100%;height:100%}.qrcode>.mask[data-v-2caae675]{display:flex;justify-content:center;align-items:center;color:#fff;font-size:1.5rem;position:absolute;top:0;left:0;right:0;background:rgba(0,0,0,.6);-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px)}", ""]);
// Exports
module.exports = exports;
